(function () {
  function updateCartProgress(cartTotal) {
    const threshold = window.FREE_SHIPPING_THRESHOLD;

    if (!threshold) {
      return;
    }

    const progress = Math.min((cartTotal / threshold) * 100, 100);
    const remaining = Math.max(threshold - cartTotal, 0);

    const fill = document.querySelector('.cart-progress__fill');
    const message = document.querySelector('.cart-progress__message');

    if (!fill || !message) return;

    fill.style.width = `${progress}%`;

    if (remaining > 0) {
      message.textContent = `Add $${(remaining / 100).toFixed(2)} more to qualify for free shipping`;
    } else {
      message.textContent = `You qualify for free standard shipping`;
    }
  }

  function refreshCartProgress() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        updateCartProgress(cart.total_price);
      })
      .catch(() => {
        console.warn('Cart fetch failed');
      });
  }

  // Run on first load
  document.addEventListener('DOMContentLoaded', refreshCartProgress);

  // Dawn cart updates (this works in Dawn)
  document.addEventListener('cart:refresh', refreshCartProgress);

  // EXTRA safety (covers remove/add edge cases)
  const observer = new MutationObserver(() => {
    refreshCartProgress();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
